
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, tap} from 'rxjs';
import { AuthService } from '../modulos/auth/services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';


@Injectable({
  providedIn: 'root'
})


export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private store: Store<AppState>,
    private usuarioService: AuthService, 
    private router: Router,
    
    ) { }
  
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
      this.store.select("usuarioApp").subscribe((resp)=>{
        
   if (resp["access_token"]) {    
          return true;            
        }else{
          return this.router.navigate(['login/auth']);
        }
      })
      return true;
    }
  
    canActivate(
      next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {      
        this.store.select("usuarioApp").subscribe((resp)=>{      
     if (resp["access_token"]) {

           return true;            
          }else{  
            return false;
          }
        })
        return true;
    }



}
